import { render, staticRenderFns } from "./ProjectOperate.vue?vue&type=template&id=a6082cb4&scoped=true"
import script from "./ProjectOperate.vue?vue&type=script&lang=js"
export * from "./ProjectOperate.vue?vue&type=script&lang=js"
import style0 from "./ProjectOperate.vue?vue&type=style&index=0&id=a6082cb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6082cb4",
  null
  
)

export default component.exports